/* global FileReader */
import { useState } from 'react';
import Compressor from 'compressorjs';

const useLocalImage = ({ onReupload }) => {
  const [uploadErrorMessage, setUploadErrorMessage] = useState('');
  const [currentFileName, setCurrentFileName] = useState('');
  const [currentFile, setCurrentFile] = useState(null);

  const cleanImageData = () => {
    setUploadErrorMessage('');
    setCurrentFileName('');
    setCurrentFile(null);
  };

  const handleFiles = (files, compress = false) => {
    const fileList = [...files];

    if (fileList.length > 1) {
      setUploadErrorMessage('Only one file is allowed');
    } else if (fileList.length === 1) {
      const [file] = fileList;

      readImage(file, compress);
    }
  };

  const readImage = (file, compress) => {
    const hasImageFile = /(image\/(png|jpg|jpeg))/gi;

    if (!hasImageFile.test(file.type)) {
      setUploadErrorMessage('Only png, jpg, jpeg, image files are allowed');
    } else {
      const reader = new FileReader();

      if (!compress) {
        reader.readAsDataURL(file);
      } else {
        // eslint-disable-next-line no-new
        new Compressor(file, {
          quality: 0.8,
          maxWidth: 768,
          maxHeight: 1024,
          success: (compressedResult) => {
            reader.readAsDataURL(compressedResult);
          },
        });
      }

      reader.onloadend = (event) => {
        const { result } = event.target;

        if (result === currentFile) {
          onReupload();
        } else {
          setCurrentFile(result);
        }
      };

      setCurrentFileName(file.name);

      reader.onerror = () => {
        // Add this error on bugsnag
        setUploadErrorMessage('An error reading the file has occurred');
      };
    }
  };

  return {
    handleFiles,
    currentFile,
    uploadErrorMessage,
    currentFileName,
    cleanImageData,
  };
};

export default useLocalImage;
